import {
  fromLocalToDBEndOfDayTimestamp,
  fromLocalToDBStartOfDayTimestamp,
  fromLocalToEndOfDayTimestamp,
  fromLocalToStartOfDayTimestamp,
} from './date';

export const handleDateTypeStart = (dateType, dateValue) => {
  if (dateType) return fromLocalToDBStartOfDayTimestamp(dateValue);
  return fromLocalToStartOfDayTimestamp(dateValue);
};

export const handleDateTypeEnd = (dateType, dateValue) => {
  if (dateType) return fromLocalToDBEndOfDayTimestamp(dateValue);
  return fromLocalToEndOfDayTimestamp(dateValue);
};
